/**
 * Arma una etiqueta legible para el lote.
 * @param {Object} comment - Comentario de calidad.
 * @returns {string} Etiqueta de lote.
 */
export const getLotLabel = (comment) => {
  if (!comment) return 'Sin lote';
  const block = (comment.block_number || '').trim();
  const number = (comment.lot_number || '').trim();
  const label = `${block}${block ? '-' : ''}${number}`.trim();
  return label || 'Sin lote';
};

/**
 * Arma etiqueta combinada loteo + lote.
 * @param {Object} comment - Comentario de calidad.
 * @returns {string} Etiqueta combinada.
 */
export const getAllotmentLotLabel = (comment) => {
  const allotment = (comment?.allotment_name || '').trim();
  const lot = getLotLabel(comment);
  if (allotment && lot) {
    return `${allotment} - ${lot}`;
  }
  return allotment || lot || '-';
};

/**
 * Divide texto en líneas de hasta 40 caracteres.
 * @param {string} value - Texto a formatear.
 * @returns {string[]} Líneas del texto.
 */
export const splitCellText = (value = '') => {
  const text = String(value);
  if (text.length <= 40) return [text];
  const lines = [];
  for (let i = 0; i < text.length; i += 40) {
    lines.push(text.slice(i, i + 40));
  }
  return lines;
};

/**
 * Filtra comentarios por texto y filtros de loteo/lote.
 * @param {Array} comments - Lista de comentarios.
 * @param {Object} filters - Filtros activos.
 * @param {string} filters.searchTerm - Texto libre.
 * @param {string} filters.uuid_allotment - UUID del loteo.
 * @param {string} filters.uuid_lot - UUID del lote.
 * @returns {Array} Comentarios filtrados.
 */
export const filterQualityComments = (comments = [], filters = {}) => {
  const { searchTerm = '', uuid_allotment = '', uuid_lot = '' } = filters;
  const term = searchTerm.trim().toLowerCase();

  return comments.filter((comment) => {
    if (uuid_allotment && comment.uuid_allotment !== uuid_allotment) {
      return false;
    }
    if (uuid_lot && comment.uuid_lot !== uuid_lot) {
      return false;
    }
    if (!term) return true;

    const task = (comment.task_name || '').toLowerCase();
    const observations = (comment.observations || '').toLowerCase();
    const allotment = (comment.allotment_name || '').toLowerCase();
    const lotLabel = getLotLabel(comment).toLowerCase();
    return (
      task.includes(term) ||
      observations.includes(term) ||
      allotment.includes(term) ||
      lotLabel.includes(term)
    );
  });
};
